import React from 'react';
import Select from 'react-select';
import { StaticImage } from '../../utils/image';
import { Card, Input, Radio, Skeleton, Button, Switch } from 'antd';
import { AudioOutlined } from '@ant-design/icons';
import './index.scss';
import './progress.scss';
const SubscribeTab03 = () => {
  const { Search } = Input;
  const dataArr = [
    {
      timeLabel: 'อัพเดทล่าสุด : 10 มี.ค. 64',
      timeLabelIcon: '/images/login/sync-duotone-1.png',
      eyeLabel: 'ดูรายละเอียด',
      eyeLabelIcon: '/images/login/eye-duotone-2.png',
      cardLabel:
        'โครงการแก้ไขเพิ่มเติมพระราชบัญญัติหลักทรัพย์และตลาดหลักทรัพย์ ...',
      cardLabelColor: '#1a57a7',
      cardShowStatusImg: '/images/login/heart-circle-duotone-2.png',
      cardSemiLabel: [
        {
          label: 'อสังหาริมทรัพย์',
          icon: '/images/login/books-duotone-1.png',
          labelSize: '182px',
        },
      ],
    },
    {
      timeLabel: 'อัพเดทล่าสุด : 5 มี.ค. 64',
      timeLabelIcon: '/images/login/sync-duotone-1.png',
      eyeLabel: 'ดูรายละเอียด',
      eyeLabelIcon: '/images/login/eye-duotone-2.png',
      cardLabel:
        'โครงการแก้ไขเพิ่มเติมพระราชบัญญัติหลักทรัพย์และตลาดหลักทรัพย์ ...',
      cardLabelColor: '#1a57a7',
      cardShowStatusImg: '/images/login/heart-circle-duotone-2-color.png',
      cardSemiLabel: [
        {
          label: 'อสังหาริมทรัพย์',
          icon: '/images/login/books-duotone-1.png',
          labelSize: '182px',
        },
      ],
    },
  ];
  const onChange = (checked) => {
    console.log(`switch to ${checked}`);
  };
  const onSearch = (value) => console.log(value);
  return (
    <div>
      <div className='record-search-section'>
        <Search
          placeholder='ค้นหา'
          allowClear
          onSearch={onSearch}
          style={{ width: 678 }}
        />
        <div className='record-search-swith'>
          <Switch defaultChecked onChange={onChange} />
        </div>
        <div>เฉพาะที่ฉันชอบ</div>
      </div>
      {/* {dataArr.map((res, i) => {
        return (
          <div key={i}>
            <div className='alterbodycontainer'>
              <img
                src={StaticImage(res.timeLabelIcon)}
                className='clock-solid-alter'
              />

              <div className='col-subtab1-container col-clock-container'>
                <div className='col'>
                  <div className='alterbodytimelabel'>{res.timeLabel}</div>
                </div>
              </div>
              <img
                src={StaticImage(res.eyeLabelIcon)}
                className='subscribe-eye-duotone-2'
              />
              <div className='alter-body-eye-label'>{res.eyeLabel}</div>
            </div>
            <div className='alter-body-border-container'>
              <div style={{ display: 'flex' }}>
                <label
                  style={{
                    color: res.cardLabelColor,
                    margin: '27 0 0 0',
                    fontSize: '24px',
                  }}
                >
                  {' '}
                  {res.cardLabel}{' '}
                </label>
                <div className='subscribe-heart-circle-out'>
                  <img
                    src={StaticImage(res.cardShowStatusImg)}
                    className='subscribe-heart-circle-duotone-2'
                  />
                </div>
              </div>
              <div style={{ display: 'flex' }}>
                {res.cardSemiLabel.map((r, ii) => {
                  return (
                    <div key={ii}>
                      <div
                        className='subscribe-Rectangle-3-copy-5'
                        style={{ width: r.labelSize }}
                      >
                        <div className='subscribe-Rectangle-3-copy-5-style'>
                          <img
                            src={StaticImage(r.icon)}
                            className='subscribe-books-duotone-1 '
                          />
                          {r.label}
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div
                  className='alter-Rounded-Rectangle-6'
                  style={{ margin: '0 0 0 20px' }}
                >
                  <div className='alter-rountangle-body-container'>
                    <img
                      src={StaticImage('/images/layer-18.png')}
                      className='alter-Layer-4'
                    />
                    <div className='alter-rountangle-text'>ก.ล.ต.</div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    color: '#488345',
                    margin: '0 10px 0 40px',
                  }}
                >
                  <img
                    src={StaticImage(
                      '/images/login/balance-scale-light-01.png'
                    )}
                    className='subscribe-balance-scale-light'
                  />
                  <label>บังคับใช้</label>
                </div>
              </div>
            </div>
          </div>
        );
      })} */}
    </div>
  );
};

export default SubscribeTab03;
